// Business mappers
import {
  isAvailable,
  customsGA4Keys,
  productKeysGA4,
  promotionKeysGA4,
  GA4ProductKeyList,
  GA4PromotionKeyList,
} from "../../../business/mappers/productDimensions";

import warn from "../../../utils/warn";

/**
 * GA4 Builder of custom dimension/metrics for ecommerce payload.
 * @param {object} originalPayload Payload sent from the app who calls track in
 * @param {string} type Type of payload being sent: product, promotion
 * the product object
 * @return {object}
 */
export const buildGA4EcommerceCustoms = (originalPayload, type) => {
  const payload = {};
  const keys = (type === "product") ? productKeysGA4 : promotionKeysGA4;
  const customKeys = customsGA4Keys;
  const availableKeys = [...GA4ProductKeyList , ...GA4PromotionKeyList];
  const customs = {};
  // Translate keys
  // eslint-disable-next-line prefer-const
  for (let [key, value] of Object.entries(originalPayload)) {
    if (availableKeys.indexOf(key) != -1) {
      payload[keys(key)] = value;
    }
  }
  // Translate custom keys
  if (originalPayload.custom) {
    // eslint-disable-next-line prefer-const
    for (let [key, value] of Object.entries(originalPayload.custom)) {
      if (isAvailable(key)) {
        customs[customKeys(key)] = value;
      } else {
        warn(`The key ${key} is not available as ${type} dimension.`);
      }
    }
  }
  return {
    ...payload,
    ...customs,
  };
};
